import RailsAjax from "../shared/rails-ajax";

let question = document.querySelector(".true-false-question");
let answers = Array.from(document.querySelectorAll(".true-false-answer"));
let responseAlert = document.getElementById("true-false-alert");

answers.forEach(function (answer) {
  let marker = answer.getElementsByClassName("answer-marker")[0];

  function handleResponse() {
    if (
      answer.dataset.correct == "true" &&
      answer.classList.contains("mc-correct")
    ) {
      answer.classList.remove("mc-correct");
      marker.querySelector(".fa-check").classList.add("hidden");
      responseAlert.innerHTML = "";

      return;
    } else if (answer.classList.contains("mc-incorrect")) {
      answer.classList.remove("mc-incorrect");
      marker.querySelector(".fa-times").classList.add("hidden");
      responseAlert.innerHTML = "";

      return;
    }

    let xhr = RailsAjax.post(question.dataset.apiUrl, {
      participant_events_true_false_response: {
        content_true_false_question_id: question.dataset.id,
        answer_text: answer.dataset.text
      }
    });

    xhr.addEventListener("load", function (event) {
      if (answer.dataset.correct == "true") {
        answer.classList.add("mc-correct");
        marker.querySelector(".fa-check").classList.remove("hidden");
        responseAlert.innerHTML =
          '<div class="alert alert-correct" role="alert">' +
          answer.dataset.explanation +
          "</div>";
      } else {
        answer.classList.add("mc-incorrect");
        marker.querySelector(".fa-times").classList.remove("hidden");
        responseAlert.innerHTML =
          '<div class="alert alert-incorrect" role="alert">' +
          answer.dataset.explanation +
          "</div>";
      }
    });
  }

  answer.addEventListener("click", handleResponse, false);
});

//  Copyright © 2018 by Northwestern University. All Rights Reserved.
